import { ResourceInfo } from '../models/IConfig';
import { _http } from '../utilities/HttpClientService';
import { BaseService } from './BaseService';
import { ISkillEntity } from '@careerhub/core';
import { IPublicClientApplication } from '@azure/msal-browser';

export interface KnowledgeCloudServiceCallback<T> {
  (error: any, response?: T): void;
}

export class KnowledgeCloudService extends BaseService {
  private readonly knowledgeCloudApi;
  public constructor(resourceInfo: ResourceInfo, msalInstance: IPublicClientApplication) {
    super(resourceInfo, msalInstance);
    this.knowledgeCloudApi = resourceInfo.resourceBaseUrl;
  }

  public async getSearchedSkills(searchTerm: string, callback: KnowledgeCloudServiceCallback<ISkillEntity[]>) {
    const replyUrl =
      this.knowledgeCloudApi + `/search?searchTerm=${encodeURIComponent(searchTerm.toLowerCase())}&skip=0&top=10`;

    const token = await this.getAccessToken();
    var response = await _http(replyUrl, token);
    await this.parseResponse(response, callback);
  }

  // Return first object from odata response.
  private async parseResponse<T>(response: Response, callback: KnowledgeCloudServiceCallback<T>) {
    if (response.status >= 200 && response.status < 300) {
      var json = await response.json();
      if (json.value && json.value.length > 0) {
        callback(null, json.value[0] as T);
      } else {
        callback(null, json as T);
      }
    } else {
      callback(response.statusText);
    }

    return undefined;
  }
}
